import { useEffect, useState } from "react";

const useLatLng = () => {
  const [latlng, setLatlng] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      setLatlng(null);
      navigator.geolocation.getCurrentPosition(
        (e) => {
          let latitude = e.coords.latitude;
          let longitude = e.coords.longitude;
          setLatlng({
            lat: Number(latitude).toFixed(6),
            lng: Number(longitude).toFixed(6),
          });
        },
        function (error) {
          setLatlng({
            lat: null,
            lng: null,
          });
          if (error.code == error.PERMISSION_DENIED) {
            setLatlng(false);
          }
        }
      );
    } else {
      let errorMsg = 'Geolocation is not supported by this browser.';
      setLatlng({ lat: errorMsg, lng: errorMsg });
    }
  }, []);

  return latlng;
};

export default useLatLng;
